import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { NewTaskTakeFive } from "../../../shared/models/api/models";

export type TakeFiveFormState = {
    form: NewTaskTakeFive,
    originalForm: NewTaskTakeFive,
    formValidation: boolean[],
    checkValidation: boolean,
    emailInvalid: boolean,
    useAutoPopulatedReportToEmail: boolean
}

const emptyForm: NewTaskTakeFive = {
    Id: -1
};

const createInitialState = (): TakeFiveFormState => ({
    form: Object.assign({}, emptyForm),
    originalForm: emptyForm,
    formValidation: [],
    checkValidation: false,
    emailInvalid: false,
    useAutoPopulatedReportToEmail: false
});

const takeFiveFormStateSubject = new BehaviorSubject<TakeFiveFormState>(createInitialState());

export const updateFormState = (form: NewTaskTakeFive) => {
    takeFiveFormState.setState(s => {
        s.form = form;
    });
}

const updateValidationState = (validation: boolean[]) => {
    takeFiveFormState.setState(s => {
        s.formValidation = validation;
    });
}

const isValueInvalid = (value: any) => {
    if (value === undefined) return true;
    if (typeof (value) === 'string' && !value.trim()) return true;
    return false;
}

export const usingRPAutoPopulatedReportToEmail = () => {
    takeFiveFormState.setState(d => { d.useAutoPopulatedReportToEmail = true });
}

export const enableValidation = () => {
    takeFiveFormState.setState(d => { d.checkValidation = true });
}

export const resetValidation = () => {
    takeFiveFormState.setState(d => { d.formValidation = [], d.checkValidation = false });
}

export const resetEmailValidation = () => {
    takeFiveFormState.setState(d => d.emailInvalid = false);
}

export const emailValidation = (emailValid: boolean) => {
    takeFiveFormState.setState(d => d.emailInvalid = emailValid);
}

export const handleChange = (field: string) => (event: any) => {
    let value = event;

    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }
    updateFormState({ ...takeFiveFormStateSubject.value.form, [field]: value });
    validate(field, value);
};

export const handleCheckboxChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.checked !== undefined) {
        value = value.target.checked;
    } else {
        value = false;
    }

    updateFormState({ ...takeFiveFormStateSubject.value.form, [field]: value });
    validate(field, value ? value : undefined);
}

const validate = (field: string, value: any) => {
    updateValidationState({ ...takeFiveFormStateSubject.value.formValidation, [field]: isValueInvalid(value) });
}

export const fieldInvalid = (field: string) => {
    if (!takeFiveFormStateSubject.value.checkValidation) {
        return false;
    }
    let value = Object(takeFiveFormStateSubject.value.formValidation)[field] as boolean;
    if (value === undefined) return true;
    return value;
}

export const takeFiveFormState = {
    subscribe: (setState: any) => takeFiveFormStateSubject.subscribe(setState),
    setState: (fn: (state: TakeFiveFormState) => void) => {
        var newState = Object.assign({}, takeFiveFormStateSubject.getValue());
        fn(newState);
        takeFiveFormStateSubject.next(newState);
    },
    reset: () => {
        takeFiveFormStateSubject.next(createInitialState())
    }
}